export enum VenuesActionsEnum {
  Edit = 1,
  Delete,
  Archive,
  Unarchive
}
